import type { BreakdownCell } from '@/components/ui/breakdown-tables/BreakdownTable';

/**
 * Aggregates cell values for debtors report tables.
 * Handles string columns (Type, Memo) by returning null (don't aggregate).
 * Aggregates numeric values by summing them.
 */
export const aggregateDebtorsReportCellValues = (
  values: BreakdownCell['value'][],
): BreakdownCell['value'] => {
  // Check if we're aggregating string columns across multiple cells (before filtering nulls)
  // If there are any cells (even with nulls) and any contain strings, don't aggregate
  const hasString = values.some((v) => typeof v === 'string');
  if (hasString) {
    return null; // Don't show Type/Memo at group level when aggregating detail cells
  }

  // Filter out null/undefined values for numeric aggregation
  const validValues = values.filter((v) => v !== null && v !== undefined);

  if (validValues.length === 0) {
    return null;
  }

  // If there's only one valid value, return it as-is
  if (validValues.length === 1) {
    return validValues[0];
  }

  // For multiple numeric values, sum them up
  return validValues.reduce<number>((sum, val) => {
    if (typeof val === 'number') return sum + val;
    return sum;
  }, 0);
};
